import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid,
         Paper, Snackbar, SnackbarContent,
         TextField, Typography
} from '@mui/material';
import AbEnvironment from '../auth/AbEnvironment';
import Address from '../ui/Address'
import EmailDialog from '../ui/EmailDialog';
import UserEmailForm from './UserEmailForm';
import CustomerValidationFetch from '../customer/CustomerValidationFetch';

import PageTitle from '../ui/PageTitle';
import SavingSpinner from '../ui/SavingSpinner';
//import PhoneNumberFormat from '../ui/PhoneNumberFormat';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import classNames from 'classnames';
import AppBindStyles from '../../AppBindStyles';
import { green } from '@mui/material/colors';

const abEnvironment = new AbEnvironment();
const styleSheet = theme => ({
    root: {
      flexGrow: 1,
    },
    flex: {
      flex: 1,
    },
    paper: {
      padding: theme.spacing(3),
      textAlign: 'left',
      // color: theme.palette.text.secondary,
      maxWidth: 980,
      marginTop: 16
    },
    success: {
      backgroundColor: green[300],
    },
    error: {
      backgroundColor: theme.palette.error.light,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
    close: {
      padding: theme.spacing(0.5),
    },    
});
  
class CustomerCreate extends Component {
    state = {
        dupCustomer: false,
        dupEmail: false,
        showSpinner: false,
        showInviteSpinner: false,
        saveStatus: null,
        saveMessage: null,
        snackbarOpen: false,
        parentId: abEnvironment.getUserAttribute('a_id'),
        accountType: 4,
        accountNum: '',
        accountName: '',
        description: '',
        contactLastName: '',
        contactFirstName: '',
        contactEmail: '',
        contactPhone: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        postalCode: '',
        abUserId: null,
        auth0Uid: null,
        accountRole: null,
        newAccountId: null,
        emailDialogOpen: false
    }
    componentDidMount() {
      if (abEnvironment.isSegmentActive()) { window.analytics.page(); }
    }

    goBack() {
      this.props.history.goBack();
    }
    
    goTo(route) {
      this.props.history.replace(`/${route}`);
    }
  
    handleEmailClose = () => {
      this.setState({emailDialogOpen: false});
      //Here they should go to new account they created.  If it turns out they did not
      //really send email, they can always resend.
      let replaceUrl = 'customer?accountId=' + this.state.newAccountId;
      this.goTo(replaceUrl);
   };
  
   getAccountNumberFieldLabel() {
  
      if (this.state.accountNum) {
        return "Account identifier";
      } else {
        return "An optional internal identifier";
      }

  }
  
  getAccountNumberHelperText() {
      if (this.state.accountNum) {
        return "An optional internal name or number for your customer";
      } else {
        return "";
      }

  }

    showSpinner() {
        return this.state.showSpinner;
    }

    showInviteSpinner() {
      return this.state.showInviteSpinner;
    }


    enableSaveAndInvite() {
      const { validateEmail } = this.props.auth;

      if (this.state.dupCustomer) {
        return false;
      }

      if (this.state.dupEmail) {
        return false;
      }

      if (this.state.accountName == null || this.state.accountName.length === 0)
        return false;

      if (this.state.contactLastName == null || this.state.contactLastName.length === 0)
        return false;

      if (this.state.contactFirstName == null || this.state.contactFirstName.length === 0)
        return false;

      if (this.state.contactEmail == null || this.state.contactEmail.length === 0)
        return false;

      // Is email an email address?
      let emailOk = validateEmail(this.state.contactEmail);
      if (! emailOk)
        return false;

      return true;
    }

    setCountry    = (country)    => { this.setState({country:    country}); }  
    setRegion     = (region)     => { this.setState({state:      region}); }  
    setCity       = (city)       => { this.setState({city:       city}); }  
    setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
    setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
    setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

    handleSnackbarClose = (event, reason) => { /*clickaway,autoHideDuration,timeout*/
      this.setState({ snackbarOpen: false, saveStatus: '', saveMessage: '' });
    };

    validateCustomer = (ev) => {

      let accountId = abEnvironment.getUserAttribute('a_id');
  
      //this gets a list of all the apps associated with the program
      CustomerValidationFetch.fetch(accountId, this.state.accountName).toPromise()
      .then(cvf => {
        if (cvf.allAccountTs.totalCount === 1) {
          this.setState({dupCustomer: true});
        } else {
          this.setState({dupCustomer: false});
        }
        
      })
      .catch(err => {
        //nothing to do....
      })
  
    }
  
    validateEmailDuplicate = (ev) => {

      const { callPartnerApi, logError } = this.props.auth;

  
      // Check on uniqueness prior to account or user persistence.
      callPartnerApi('appbind/usercount/' + this.state.contactEmail,
                     'GET',
                     null)
      .then(response => {
        return response.json();
      })
      .then(data => {
        if (data.userCount != null)
        {
          if (data.userCount > 0)
          {
            this.setState({dupEmail: true});

          } else {
            this.setState({dupEmail: false});
          }
        }
        else
        {
          throw(data);
        }
      }).catch(err => {
        logError('Exception in CustomerCreate.js: ' + err);
      })
  
    }
  
    render() {
        const { validateEmail, isAuthenticated, isAuthenticatedReseller, needAssent } = this.props.auth;
        const classes = this.props.classes;

        if (!isAuthenticated() || needAssent()) {
          return (
            <Redirect to='/home' />
          );
        } else if (isAuthenticatedReseller()) {
          // Fill the prop values...
          let address = {
            country:    this.state.country,
            state:      this.state.state,
            city:       this.state.city,
            postalCode: this.state.postalCode,
            address1:   this.state.address1,
            address2:   this.state.address2
          };
          let regionLabel = "Region";

          let emailError = false;
          if (this.state.contactEmail != null && this.state.contactEmail !== '') {
            let emailOk = validateEmail(this.state.contactEmail);
            if (! emailOk) {
              emailError = true;
            }
          }                    
          
          const emailSubject = 'Invitation from ' + abEnvironment.getUserAttribute('a_accountName');
          const emailTextBody = this.state.contactFirstName + `,\n\nWe'd like to purchase and manage subscriptions for your project.\n\nPlease use our client portal to securely link your credit card, debit card, or bank account. Then we can automatically and transparently expense subscriptions to you.\n\n- ` + abEnvironment.getUserAttribute('a_accountName');

          return (
            <Grid container spacing={3} direction="row" justifyContent="flex-start">
              <Grid item xs={12}>
                <PageTitle title="Add a new customer" showBackButton={true} name="Customers" noMargin={true} history={this.props.history}/>
              </Grid>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <Grid container spacing={2} direction="row" justifyContent="flex-start">
                    <Grid item xs={12}>
                      <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
                        Account
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        error={this.state.dupCustomer}
                        id="customer-name" label="Customer name *"
                        value={ this.state.accountName }
                        onBlur={() => { this.validateCustomer() }}
                        onChange={ (e) => this.setState({ accountName: e.target.value }) }
                        inputProps={{ maxLength: 64 }}
                        helperText={this.state.dupCustomer ? 'Customer already exists with this name' : ''}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        id="account-num" label={this.getAccountNumberFieldLabel()}
                        value={ this.state.accountNum }
                        onChange={ (e) => this.setState({ accountNum: e.target.value }) }
                        helperText={this.getAccountNumberHelperText()}
                        inputProps={{ maxLength: 64 }}
                      />
                    </Grid>
                    {/*
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="name-helper">Description</InputLabel>
                        <Input id="description" value={this.state.description} 
                              onChange={(e) => this.setState({ description: e.target.value })} />
                      </FormControl>
                    </Grid>
                    */}
                    <Grid item xs={12}>
                      <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                        Primary contact
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="first-name" label="First name *"
                        value={ this.state.contactFirstName }
                        onChange={ (e) => this.setState({ contactFirstName: e.target.value }) }
                        inputProps={{ maxLength: 32 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="last-name" label="Last name *"
                        value={ this.state.contactLastName }
                        onChange={ (e) => this.setState({ contactLastName: e.target.value }) }
                        inputProps={{ maxLength: 32 }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    {/* 
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="email">Email</InputLabel>
                        <Input id="email" value={this.state.contactEmail}
                              onChange={(e) => this.setState({ contactEmail: e.target.value })} />
                      </FormControl>
                      */}
                      <TextField  data-recording-ignore="mask"
                        id="email" label="Email *"
                        error={this.state.dupEmail || emailError}
                        value={ this.state.contactEmail }
                        onBlur={() => { this.validateEmailDuplicate() }}
                        onChange={ (e) => this.setState({ contactEmail: e.target.value }) }
                        helperText={this.state.dupEmail ? 'User already exists with this email' : ''}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Paper elevation={1}>
                        <Grid container spacing={1} direction="row" justifyContent="flex-start" style={{padding: '16px'}}>
                        <Grid item xs={12}>
                            <div style={{display:"flex"}}>
                              <Typography variant="body1">
                                <strong>Tip.</strong>&nbsp;&nbsp;Your customer will only be emailed when you say so.
                              </Typography>
                            </div>
                          </Grid>      
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        {/* remove this grid item when we bring phone back */}
                    </Grid>
                    {/*<Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="phone" label="Phone" 
                        value={ this.state.contactPhone }
                        onChange={ (e) => this.setState({ contactPhone: e.target.value }) }
                        InputProps={{
                          inputComponent: PhoneNumberFormat,
                        }}
                      />
                      </Grid>*/}
                    <Grid item xs={12}>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h6" style={AppBindStyles.sectionTitle}>
                        Mailing address
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Address
                        showRequired={false}
                        address={address}
                        regionLabel={regionLabel}
                        setCountryCodeState={this.setCountry}
                        setRegionCodeState={this.setRegion}
                        setCityState={this.setCity}
                        setPostalCodeState={this.setPostalCode}
                        setAddress1State={this.setAddress1}
                        setAddress2State={this.setAddress2}
                      />
                    </Grid>
                    <Grid item xs={12}>
                    <div style={{display:'inline'}}>
                      { !this.showSpinner() && !this.showInviteSpinner() && this.enableSaveAndInvite() &&
                      <Button variant="contained" color="primary"  style={AppBindStyles.bottomButton}  onClick={() => {this._createCustomer()}}>
                        Save
                      </Button>
                      }
                      { ((!this.showSpinner() && !this.enableSaveAndInvite()) || this.showInviteSpinner()) &&
                      <Button variant="contained" color="primary"  disabled  style={AppBindStyles.bottomButton} >
                        Save
                      </Button>
                      }
                      { this.showSpinner() &&
                      <Button disabled={false} color="primary" variant="contained"  style={AppBindStyles.bottomButton} >
                        <SavingSpinner/></Button> }
                      
                      { !this.showSpinner() && !this.showInviteSpinner() && this.enableSaveAndInvite() &&
                      <Button color="primary" variant="outlined"  style={AppBindStyles.bottomButton}  onClick={() => {this._createCustomerAndInvite()}}>
                        Save and Invite
                      </Button>
                      }
                      { ((!this.showInviteSpinner() && !this.enableSaveAndInvite()) || this.showSpinner()) &&
                      <Button color="primary" variant="outlined" disabled  style={AppBindStyles.bottomButton}>
                        Save And Invite
                      </Button>
                      }
                      { this.showInviteSpinner() &&
                      <Button disabled={false} color="primary" variant="outlined"  style={AppBindStyles.bottomButton} >
                        <SavingSpinner/></Button> }

                        <Snackbar
                          anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                          }}
                          open={this.state.snackbarOpen}
                          onClose={this.handleSnackbarClose}
                        >
                          <SnackbarContent
                            className={classNames(classes.message, classes[this.state.saveStatus])}
                            onClose={this.handleSnackbarClose}
                            message={
                              <Typography variant="body1">
                                  {this.state.saveMessage}
                              </Typography>
                            }
                            action={[
                              <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                className={classes.close}
                                onClick={this.handleSnackbarClose}
                                size="large">
                              <CloseIcon />
                            </IconButton>
                          ]}
                        />
                      </Snackbar>

                    </div>

                    </Grid>
                  </Grid>
                </Paper>

                <EmailDialog
                    title="Customize your email"
                    open={this.state.emailDialogOpen}
                    onClose={this.handleEmailClose} >

                      <UserEmailForm
                        auth={this.props.auth}
                        emailTo={this.state.contactEmail}
                        emailSubject={emailSubject}
                        emailTextBody={emailTextBody}
                        userId={this.state.abUserId}
                        auth0Uid={this.state.auth0Uid}
                        pAccountId={abEnvironment.getUserAttribute('a_id')}
                        accountId={this.state.newAccountId}
                        userArole={this.state.accountRole} 
                        onClose={this.handleEmailClose}>
                      </UserEmailForm>
                </EmailDialog>
              </Grid>
            </Grid>
          );
        } else {
          return (
            <Redirect to='/home' />
          );
        }
    }

    _createCustomer = () => {

      if (abEnvironment.isSegmentActive()) { window.analytics.track('Customer create saving customer'); }   
      const { callPartnerApi } = this.props.auth;
 
      this.setState({ showSpinner: true });
      const { parentId, accountNum, accountName, description,
              contactLastName, contactFirstName, contactEmail, contactPhone,
              address1, address2, city, state, country, postalCode } = this.state;
      
      let theNewAccountId = null;

      let aPjwt = abEnvironment.getPjwt();

      let payload = {
        operation: "createCustomerAndProject",
        params: {
          pJwt: aPjwt,
          parentId: parentId,
          accountNum: accountNum,
          accountName: accountName,
          description: description,
          contactLastName: contactLastName,
          contactFirstName: contactFirstName,
          contactEmail: contactEmail,
          contactPhone: contactPhone,
          address1: address1,
          address2: address2,
          city: city,
          state: state,
          country: country,
          postalCode: postalCode
        }
      };
 
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
      .then(resp => {
        return resp.json();
      })
     .then(response => {

        if (response.err != null)
        {
          throw response.err;  
        }

        theNewAccountId = response.data.createAccountT.accountT.accountId;
        // Increment the customer count...
        let custCount = parseInt(abEnvironment.getUserAttribute("cust_count"), 10) + 1;
        abEnvironment.setUserAttribute("cust_count", custCount);

        return null;
      })
      .then(response => {
        this.setState({ showSpinner: false });
        let replaceUrl = 'customer?accountId=' + theNewAccountId;
        if (abEnvironment.isSegmentActive()) { window.analytics.track('Customer create saved customer'); }   
        this.goTo(replaceUrl);
      })
      .catch(error => {
        //console.log('Customer create mutation error: ' + error);
        let theError = 'Unable to save new customer';

        if (error.errMessage) {
          theError = error.errMessage;  //more specific
        }

        this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: theError });
        // this.goBack();
      });
    }

    _createCustomerAndInvite = () => {
      const { callPartnerApi } = this.props.auth;
      if (abEnvironment.isSegmentActive()) { window.analytics.track('Customer create saving and inviting customer'); }   

      this.setState({ showInviteSpinner: true });
      const { parentId, accountType, accountNum, accountName, description,
              contactLastName, contactFirstName, contactEmail, contactPhone,
              address1, address2, city, state, country, postalCode } = this.state;

      let pAccountId = abEnvironment.getUserAttribute('a_id');
      let aPjwt = abEnvironment.getPjwt();
        
      let theNewAccountId = '';

      let abUserId = '';
      let auth0Uid = '';
      let accountRole = '';
 
      let payload = {
        operation: "createCustomerAndProject",
        params: {
          pJwt: aPjwt,
          parentId: parentId,
          accountNum: accountNum,
          accountName: accountName,
          description: description,
          contactLastName: contactLastName,
          contactFirstName: contactFirstName,
          contactEmail: contactEmail,
          contactPhone: contactPhone,
          address1: address1,
          address2: address2,
          city: city,
          state: state,
          country: country,
          postalCode: postalCode
        }
      };
 
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
      .then(resp => {
        return resp.json();
      })
     .then(response => {

        if (response.err != null)
        {
          throw response.err;  
        }

        theNewAccountId = response.data.createAccountT.accountT.accountId;
        return theNewAccountId;

      })
      .then(theId => {
        // Call the user create 
        return callPartnerApi('appbind/user',
                              'POST',
                              {
                               'pjwt':aPjwt,
                               'accountId': theId,
                               'pAccountId': pAccountId,
                               'accountType': accountType,
                               'userRole': 0,
                               'lastName': contactLastName,
                               'firstName': contactFirstName,
                               'email': contactEmail,
                               'phone': contactPhone,
                               'address1': address1,
                               'address2': address2,
                               'city': city,
                               'state': state,
                               'country': country,
                               'postalCode': postalCode
                              });
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        //save off new user information...this will later update state - see below
        abUserId = response.abUserId;
        auth0Uid = response.auth0Uid;
        accountRole = response.accountRole;
      })
      .then(response => {
        // Increment the customer count...
        let custCount = parseInt(abEnvironment.getUserAttribute("cust_count"), 10) + 1;
        abEnvironment.setUserAttribute("cust_count", custCount);

        if (abEnvironment.isSegmentActive()) { window.analytics.track('Customer create saved customer'); }   
        this.setState({ showInviteSpinner: false, emailDialogOpen: true, abUserId: abUserId, auth0Uid: auth0Uid, accountRole: accountRole, newAccountId: theNewAccountId });
      })
      .catch(error => {
        //console.log('Customer create mutation error: ' + error);
        let theError = 'Unable to save and invite a new customer';
        if (error.errMessage != null) {
          theError = error.errMessage;
        }
        this.setState({ showInviteSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: theError });
        // this.goBack();
      });
    }
}

CustomerCreate.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(CustomerCreate);